import { QUERY_KEYS } from 'api/query-keys';
import { useQuery } from 'react-query';
import { EnvironmentService, SharedApiService } from 'shared/services';

const environmentConfigurationQueryCacheMs =
  EnvironmentService.getVariable('ENV') === 'test' ? 0 : 60_000;

const useGetEnvironmentConfiguration = (enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.environmentConfiguration(),
    queryFn: async () => await SharedApiService.getEnvironmentConfiguration(),
    enabled,
    staleTime: environmentConfigurationQueryCacheMs,
    cacheTime: environmentConfigurationQueryCacheMs,
  });

export { useGetEnvironmentConfiguration };
